function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


const imageWithTextAutoplayList = document.querySelector('[data-autoplay-list-time]');
let time = null;
let summsItems = null;
if(imageWithTextAutoplayList){
  time = +imageWithTextAutoplayList.getAttribute('data-autoplay-list-time') * 1000;
  summsItems = imageWithTextAutoplayList.querySelectorAll('summary');
}
const changeImage = (summ) => {
  const imgSrc = summ.getAttribute('data-image');
  const container = summ.closest('.image-with-text__grid');
  if(container){
    const nodeChangeImage = container.querySelector('[data-change-image]');
    if (nodeChangeImage != null) {
      summsItems.forEach((item) => {
        if (item != summ) {
          item.parentNode.removeAttribute('open');
          item.setAttribute('aria-expanded', false);
        }
      });
      nodeChangeImage.classList.remove('__image-changed');
      nodeChangeImage.innerHTML = imgSrc;
      setTimeout(() => {
        nodeChangeImage.classList.add('__image-changed');
      }, '100');
    }
  }
};
const currentSlideIndex = ()=>{
  for (let index = 0; index < summsItems.length; index++) {
    if (summsItems[index].getAttribute('aria-expanded') === 'true') {
      return index;
    }
  };
};

const nextSlide = () => {
  const currentSlide = currentSlideIndex();
  const nextIndx = (currentSlide + 1) % summsItems.length;
  const next = summsItems[nextIndx];
  next.setAttribute('aria-expanded', !next.closest('details').hasAttribute('open'));
  next.closest('details').setAttribute('open', '')
  changeImage(next);
}
const slideShowImgId = time != null ? setInterval(nextSlide, time) : null;

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    if (!event.currentTarget.closest('details').hasAttribute('open')) {
      changeImage(event.currentTarget);
    }
    clearInterval(slideShowImgId);
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container) return;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
if (elementToFocus) {
  elementToFocus.focus();
}
  

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

/* ⚠️ NOT the live mobile menu. <header-drawer> is only rendered by
   snippets/header-drawer.liquid, which only the dead
   snippets/_old-header-backup.liquid reaches. The live mobile menu is the
   .eb-drawer-overlay in sections/header.liquid, driven by assets/header-eb.js —
   fix mobile-menu bugs there, not here. Kept (unreached) pending the dead-code
   cleanup. Historical note: this was the <dialog>.showModal() version of the
   Dawn header drawer. */
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-menu-trigger]');
    this.closeButton = this.querySelector('[data-menu-close]');

    this.trigger.addEventListener('click', this.open.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.dialog.addEventListener('click', this.onDialogClick.bind(this));
    this.dialog.addEventListener('cancel', this.onDialogCancel.bind(this));
    this.dialog.addEventListener('close', this.onDialogClose.bind(this));

    this.dialog.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSubmenuSummaryClick.bind(this));
    });
    this.dialog
      .querySelectorAll(
        '.menu-drawer__close-button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
      )
      .forEach((btn) => btn.addEventListener('click', this.onSubmenuBackClick.bind(this)));
  }

  open() {
    if (this.dialog.open) return;
    this.dialog.showModal();
    /* Without this, .showModal() autofocuses the first focusable
       descendant (the X close button), and Chrome's :focus-visible
       heuristic treats that as keyboard focus — drawing a visible
       outline on the X every time the menu opens. Move focus to the
       dialog itself instead; tab still walks into the close button. */
    this.dialog.focus();
    this.trigger.setAttribute('aria-expanded', 'true');
    /* Belt-and-braces body scroll lock for iOS Safari, which doesn't
       always prevent rubber-band scroll behind a modal <dialog>. */
    document.documentElement.classList.add('menu-drawer-open');
  }

  close() {
    if (!this.dialog.open) return;
    this.dialog.close();
  }

  onDialogClick(event) {
    /* Backdrop click: target is the dialog itself, not any descendant. */
    if (event.target === this.dialog) this.close();
  }

  onDialogCancel(event) {
    /* ESC: if a submenu is open, back out of it instead of closing the
       whole dialog. */
    const openSubmenu = this.dialog.querySelector('details[open]');
    if (openSubmenu) {
      event.preventDefault();
      this.closeSubmenu(openSubmenu);
    }
  }

  onDialogClose() {
    this.trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('menu-drawer-open');
    /* Reset any open submenus so the drawer reopens at the top level. */
    this.dialog.querySelectorAll('details[open]').forEach((d) => {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
    });
    this.dialog.querySelectorAll('.submenu-open').forEach((el) => {
      el.classList.remove('submenu-open');
    });
  }

  onSubmenuSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentNode;
    /* Skip the in-drawer search disclosure — it's a real <details> we
       want to behave natively (toggle open/closed without slide-in). */
    if (details.classList.contains('menu-drawer__search-disclosure')) return;
    if (details.hasAttribute('open')) return;

    const parentMenu = details.closest('.has-submenu');
    setTimeout(() => {
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
      if (parentMenu) parentMenu.classList.add('submenu-open');
    }, 100);
  }

  onSubmenuBackClick(event) {
    const details = event.currentTarget.closest('details');
    this.closeSubmenu(details);
  }

  closeSubmenu(details) {
    const parentMenu = details.closest('.submenu-open');
    if (parentMenu) parentMenu.classList.remove('submenu-open');
    details.classList.remove('menu-opening');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    /* Wait out the slide-out transition before removing [open], same
       400ms window MenuDrawer.closeAnimation uses. */
    setTimeout(() => details.removeAttribute('open'), 400);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    // Lazy body (snippets/_card-modal.liquid `lazy: true`, used by sold-out product
    // cards): the notify form ships inert in a <template> and is stamped in on first open.
    const lazyContent = this.querySelector('template[data-modal-lazy]');
    if (lazyContent) lazyContent.replaceWith(lazyContent.content.cloneNode(true));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');

    // Autoplay sections (data-autoplay="true") load lazily on scroll-into-view
    // — the video is only requested from the network when the section is
    // about to become visible. Avoids fetching multi-MB MP4s on initial load
    // for below-the-fold autoplay videos. Falls back to immediate load if
    // IntersectionObserver isn't supported.
    if (this.getAttribute('data-autoplay') === 'true') {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            observer.disconnect();
            this.loadContent(false);
          }
        }, { rootMargin: '800px 0px' });
        // Wide rootMargin so the multi-MB video has time to download a
        // playable chunk before it scrolls into view, even at fast scroll
        // velocities. Tighter margins (~200px) caused visible empty-state
        // pop-in during quick scrolls.
        observer.observe(this);
      } else {
        this.loadContent(false);
      }
      return;
    }

    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // Only stop other media for a user-initiated (focused) load — e.g. clicking
    // a poster to play a video with sound. Scroll-triggered ambient autoplay
    // loads (loadContent(false), data-autoplay) must NOT call pauseAllMedia:
    // it pauses EVERY <video> on the page (see pauseAllMedia), so a second
    // ambient loop scrolling into view would stomp an already-playing one (the
    // About-page montage bug — it got paused the moment the less-plastic loop
    // loaded and never resumed).
    if (focus) window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        this.enforceAutoplay(deferredElement);
      }
    }
  }

  // Robust autoplay for muted/playsinline videos. Some clips (notably the
  // larger montage MP4s) have `.play()` called before enough is buffered, so
  // the promise rejects or the element stalls and stays `paused`. We:
  //   1. attempt play immediately, and again on loadeddata/canplay if it isn't
  //      yet playing (covers "called too early / not enough buffered"),
  //   2. re-issue play() whenever the video pauses unexpectedly — i.e. not
  //      because it `ended` (these loop, so they don't) and while it's still
  //      connected + not hidden.
  // Guarded against infinite loops via a short retry budget that resets each
  // time the video is actually observed playing. Generic — helps any
  // data-autoplay video, not just the montage.
  enforceAutoplay(video) {
    if (video._autoplayEnforced) return;
    video._autoplayEnforced = true;

    let retries = 0;
    const MAX_RETRIES = 30;

    const isEligible = () =>
      video.isConnected &&
      !video.ended &&
      document.visibilityState !== 'hidden' &&
      video.offsetParent !== null;

    const tryPlay = () => {
      if (!isEligible()) return;
      if (!video.paused) return;
      if (retries >= MAX_RETRIES) return;
      retries += 1;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };

    // Reset the retry budget once it's genuinely playing, so a later
    // unexpected pause gets its own fresh set of attempts.
    video.addEventListener('playing', () => { retries = 0; });

    // Retry as the video becomes ready to actually render frames.
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);

    // If it stalls or the browser pauses it unexpectedly, kick it again.
    video.addEventListener('pause', () => {
      if (!isEligible()) return;
      // Give the loop point a tick to restart on its own before forcing it.
      window.setTimeout(tryPlay, 40);
    });

    // Re-attempt when the tab/section becomes visible again.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') tryPlay();
    });

    tryPlay();
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.wrapperButtons = this.querySelector('.slider-buttons');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    // Dawn's `< 2` guard. This was `<= 2`, which left sliderItemOffset undefined
    // for exactly two slides: on mobile 2-image PDP galleries the counter read
    // "NaN", the line indicator stuck on image 1 and media-gallery.js threw on
    // slideChanged. Two slides that both fit still get their buttons hidden —
    // update() hides the wrapper when prev and next are both disabled.
    if (this.sliderItemsToShow.length < 2) {
      this.sliderItemOffset = undefined;
      if (this.wrapperButtons) this.wrapperButtons.style.visibility = 'hidden';
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;
    // Fewer than two visible slides: initPages() computed no offset, so there
    // are no pages to track (avoids NaN counters / undefined slideChanged).
    if (!this.sliderItemOffset) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    if(this.wrapperButtons){
      if (this.nextButton.hasAttribute('disabled') && this.prevButton.hasAttribute('disabled')) {
      this.wrapperButtons.style.visibility = 'hidden';
      } else {
        this.wrapperButtons.style.visibility = 'visible';
      }
    }

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Reduced motion: start paused; the (always-visible) pause/play button resumes.
        this.autoplayButtonIsSetToPlay = false;
        this.togglePlayButtonState(true);
        this.pause();
      } else {
        this.autoplayButtonIsSetToPlay = true;
        this.play();
      }
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.variantsVolumes = document.querySelectorAll("[data-variant-volume-id]");
    this.updateVariantVolume();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    this.updateVariantVolume();
  }
  // Shows the size line (snippets/_main-product-volume.liquid) for the selected
  // variant. Keyed on the variant id itself — it used to substring-match
  // location.href, which is empty of ?variant= on first load and could match
  // the wrong id. The snippet renders the selected variant's span visible
  // server-side, so this only has to follow changes (and GB/AU PDPs whose picker
  // is collapsed, where this element never exists, still show their size).
  updateVariantVolume() {
    if (!this.variantsVolumes || !this.variantsVolumes.length) return;
    let variantId = this.currentVariant && this.currentVariant.id;
    if (!variantId) {
      const idInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
      variantId = idInput && idInput.value;
    }
    if (!variantId) return;

    const target = String(variantId);
    const hasMatch = Array.from(this.variantsVolumes).some((vVol) => vVol.dataset.variantVolumeId === target);
    if (!hasMatch) return; // keep whatever the server rendered
    this.variantsVolumes.forEach((vVol) => {
      vVol.classList.toggle('visually-hidden', vVol.dataset.variantVolumeId !== target);
    });
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    // The modal's media lives in a <template> until ProductModal's first show()
    // (2026-05 perf change), so before that there is nothing to move — and
    // prepend(null) inserts a literal "null" text node into the zoom modal.
    // Reorder inside the template instead, so the selected variant's image
    // still comes first once the modal hydrates.
    const selector = `[data-media-id="${this.currentVariant.featured_media.id}"]`;
    const newMediaModal = modalContent.querySelector(selector);
    if (newMediaModal) {
      modalContent.prepend(newMediaModal);
      return;
    }
    const template = document.querySelector(
      `#ProductModal-${this.dataset.section} template[data-product-media-modal-template]`
    );
    const templateMedia = template && template.content.querySelector(selector);
    if (templateMedia && templateMedia.parentNode) templateMedia.parentNode.prepend(templateMedia);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(attempt = 0) {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => {
        if (!response.ok) throw new Error(`section render ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // A 200 that is not our section (bot challenge, error page) must not be
        // read as "no Add to cart button" = Sold out.
        if (!html.getElementById(`shopify-section-${sectionId}`)) {
          throw new Error('section render: unexpected body');
        }
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((error) => {
        // Stock Dawn had no error path: a 429/5xx or a challenge page marked an
        // in-stock variant "Sold out" (or left the button disabled) with the old
        // price showing. Retry once, then fall back to a real page load of the
        // selected variant — the server render is the only place the market
        // gates (buy-buttons.liquid) and the correct price are known.
        if (!this.currentVariant || this.currentVariant.id !== requestedVariantId) return;
        console.error(error);
        if (attempt < 1) {
          setTimeout(() => {
            if (this.currentVariant && this.currentVariant.id === requestedVariantId) this.renderProductInfo(attempt + 1);
          }, 1000);
          return;
        }
        if (this.dataset.updateUrl !== 'false') {
          window.location.assign(`${this.dataset.url}?variant=${requestedVariantId}`);
          return;
        }
        // Quick-add / featured-product contexts can't navigate away: use the
        // variant JSON's availability rather than leaving the button disabled.
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 800px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
class RegularModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.modalOverlay = this.querySelector('.modal-overlay');
    this.toggleTarget = this.getAttribute('data-btn-target');
    this.btnsToggle = document.querySelectorAll(this.toggleTarget);
    // ESC used to call this.close(), which doesn't exist (TypeError on every Escape
    // press). event.code is also undefined on autofill-generated keyups, hence the guard.
    this.detailsContainer.addEventListener('keyup', (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.closeModal());
    this.btnsToggle.forEach((btn)=>{btn.addEventListener('click', this.onClick.bind(this))});
    // Prefer the real X; the first button[type=button] can be one inside the modal content
    // (e.g. the country-region modal's picker), which left the X unbound.
    const closeButton = this.querySelector('.modal__close-button') || this.querySelector('button[type="button"]');
    if (closeButton) closeButton.addEventListener('click', this.closeModal.bind(this));
    if (this.modalOverlay) this.modalOverlay.addEventListener('click', this.closeModal.bind(this));
    this.btnsToggle.forEach((btn)=>{btn.setAttribute('role', 'button')});
  }
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }
  onClick(event) {
    event.preventDefault();
     this.openModal();
  }
  openModal() {
    this.closest('.shopify-section').classList.remove('visually-hidden');
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    // Move focus into the dialog (WCAG 2.4.3) and listen for Escape at the document
    // level: the <details> keyup listener only fires once focus is inside it.
    this.previouslyFocused = document.activeElement;
    const focusTarget = this.querySelector('.modal__close-button') || this.querySelector('button, [href], input, select, textarea');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    if (!this.onDocKeydown) {
      this.onDocKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) this.closeModal();
      };
    }
    document.addEventListener('keydown', this.onDocKeydown);
  };
  closeModal() {
    this.closest('.shopify-section').classList.add('visually-hidden');
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    if (this.onDocKeydown) document.removeEventListener('keydown', this.onDocKeydown);
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function' && document.contains(this.previouslyFocused)) {
      this.previouslyFocused.focus({ preventScroll: true });
    }
    this.previouslyFocused = null;
  };
  
}

customElements.define('regular-modal', RegularModal);

class AutoRegularModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.modalOverlay = this.querySelector('.modal-overlay');
    this.countriesExlude = this.getAttribute('data-countries-exlude') !== '' ? this.getAttribute('data-countries-exlude').split(',') : [];
    this.isApp = this.querySelector('.shopify-app-block') ? true : false;
    this.sectionID = this.getAttribute('data-section-id');
    this.fixStyles = this.getAttribute('data-fix-styles');
    this.hasShownKey = '_modalHasShown_' + this.sectionID.split('_').at(-1);
    this.delayTime = this.getAttribute('data-delay-time');
    this.detailsContainer.addEventListener('keyup', (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.closeModal());
    const closeButton = this.querySelector('.modal__close-button') || this.querySelector('button[type="button"]');
    if (closeButton) closeButton.addEventListener('click', this.closeModal.bind(this));
    this.querySelector('.btn-close-modal') ? this.querySelector('.btn-close-modal').addEventListener('click', this.closeModal.bind(this)) : null;
    this.modalOverlay.addEventListener('click', this.closeModal.bind(this));
    this.observer = this.isApp ? new MutationObserver(this.onContentChange.bind(this)) : null;
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }
  openModal() {
    this.closest('.shopify-section').classList.remove('visually-hidden');
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    if(this.observer !== null){
      this.observer.disconnect();
    }
    // Storage can throw (Safari private mode, blocked site data); showing the modal
    // again next visit is the acceptable fallback.
    try { localStorage.setItem(this.hasShownKey, this.sectionID); } catch (e) {}
  };
  closeModal() {
    this.closest('.shopify-section').classList.add('visually-hidden');
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  };
  getFormWrapper(){
    const embed = this.querySelector('form-embed');
    return (embed && embed.shadowRoot && embed.shadowRoot.querySelector('div')) || null;
  };
  isFormWrapper(){
    return this.querySelector('form-embed') || null;
  };
  getForm(container){
    return container.querySelector('form');
  };
  setCloseModalAfterSubmit(c){
    const form = this.getForm(c);
    form.addEventListener('submit',()=>{
      this.querySelector('.btn-close-modal') ? this.querySelector('.btn-close-modal').style = "display:none;" : null;
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    });
  };
  async getJSONLocalizationCustomer() {
    return fetch('/browsing_context_suggestions.json').then((response) => response.json()).then((responseJson) => {
      return responseJson.detected_values.country.handle
    });
  };
  openModalwithDelay(){
    setTimeout(() => {
      this.openModal();
    }, this.delayTime);
  };
  connectedCallback(){
    let value = null;
    try { value = localStorage.getItem(this.hasShownKey); } catch (e) {}
    const isForm = this.isFormWrapper();
    if(value !== this.sectionID){
      if(this.observer !== null){
        this.observer.observe(this, { childList: true, subtree: true });
      }else{
        if (isForm !== null) {
          this.setCloseModalAfterSubmit(this);
        }
        this.openModalwithDelay();
      }
    }else{
      this.innerHTML = '';
    }
    
  };
  openAfterFetch(){
    this.getJSONLocalizationCustomer().then((country)=>{
      const isContryExlude = this.countriesExlude.includes(country) ? false : true ;
      if (isContryExlude) {
        this.openModalwithDelay();
      }
    });
  };
  // App-form path: runs ONCE, the first time the embedded form has rendered. It used to
  // run on every childList mutation, stacking a submit listener + <style> tag and queueing
  // another open (and fetch) per batch; a mutation before the form existed threw instead.
  onContentChange() {
    if (this.formHandled) return;
    const formWrapper = this.getFormWrapper();
    if (!formWrapper || !this.getForm(formWrapper)) return;
    this.formHandled = true;
    this.observer.disconnect();
    this.setCloseModalAfterSubmit(formWrapper);
    const styleTag = document.createElement('style');
    styleTag.textContent = this.fixStyles;
    formWrapper.appendChild(styleTag);
    if (this.countriesExlude.length > 0) {
      this.openAfterFetch();
    } else {
      this.openModalwithDelay();
    }
  };
  
}

customElements.define('auto-regular-modal', AutoRegularModal);


// assets/component-bis-form.js
//
// Back-in-stock form web component. Uses fetch() against the Shopify App
// Proxy at /apps/api/back-in-stock (Element Ops Rails endpoint).
//
// Defensive against JS-load failures: the markup uses type="button" + the
// form has onsubmit="return false;", so a failed upgrade can't fall through
// to a native form submit (which would reload the page and silently close
// the modal — historically the source of "I clicked Notify Me and nothing
// happened" reports).
class BisForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onModalClosed = this.onModalClosed.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.endpoint = this.dataset.endpoint || '/apps/api/back-in-stock';
    this.shopDomain = this.dataset.shopDomain || '';
    this.productTitle = this.dataset.productTitle || '';
    this.currencyCode = this.dataset.currencyCode || '';

    this.panel = this.querySelector('[data-bis-panel]');
    this.successEl = this.querySelector('[data-bis-success]');
    this.successTextEl = this.querySelector('[data-bis-success-text]');
    this.emailInput = this.querySelector('[data-bis-email]');
    this.phoneCountrySelect = this.querySelector('[data-bis-phone-country]');
    this.phoneInput = this.querySelector('[data-bis-phone]');
    this.smsDetails = this.querySelector('[data-bis-sms]');
    this.marketingInput = this.querySelector('[data-bis-marketing]');
    this.skuInput = this.querySelector('[data-bis-sku]');
    this.countryInput = this.querySelector('[data-bis-country]');
    this.submitBtn = this.querySelector('[data-bis-submit]');
    this.messageEl = this.querySelector('[data-bis-message]');

    this.submitText =
      this.dataset.submitText ||
      (this.submitBtn && this.submitBtn.textContent.trim()) ||
      'Notify me';
    this.loadingText = this.dataset.loadingText || 'Submitting…';
    this.msgEmailRequired =
      this.dataset.msgEmailRequired || 'Please enter an email address.';
    this.msgEmailInvalid =
      this.dataset.msgEmailInvalid ||
      "That email address doesn't look right.";
    this.msgErrorGeneric =
      this.dataset.msgErrorGeneric ||
      'Something went wrong. Please try again.';
    this.msgErrorNetwork =
      this.dataset.msgErrorNetwork ||
      "Couldn't reach our server. Check your connection and try again.";

    // Click on the button is the primary path (button is type="button"
    // for the JS-load-failure defense). Submit listener catches Enter
    // keypresses inside fields. Both call the same handler.
    if (this.submitBtn) this.submitBtn.addEventListener('click', this.onClick);
    this.form.addEventListener('submit', this.onSubmit);
    document.addEventListener('variant:change', this.onVariantChange);
    // Reset form ↔ success swap when the surrounding modal closes so the
    // form is fresh on reopen.
    document.body.addEventListener('modalClosed', this.onModalClosed);
  }

  disconnectedCallback() {
    if (this.submitBtn) this.submitBtn.removeEventListener('click', this.onClick);
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    document.removeEventListener('variant:change', this.onVariantChange);
    document.body.removeEventListener('modalClosed', this.onModalClosed);
  }

  onModalClosed() {
    if (this.successEl && this.successEl.hidden) return; // never swapped
    if (this.panel) this.panel.hidden = false;
    if (this.successEl) this.successEl.hidden = true;
    this.clearMessage();
  }

  onVariantChange(event) {
    const variant = event && event.detail && event.detail.variant;
    if (!variant || !variant.sku || !this.skuInput) return;
    this.skuInput.value = variant.sku;
  }

  onClick(event) {
    event.preventDefault();
    this.submit();
  }

  onSubmit(event) {
    event.preventDefault();
    this.submit();
  }

  submit() {
    if (!this.form) return;

    const honeypot = this.form.querySelector('input[name="company"]');
    if (honeypot && honeypot.value) {
      // Bot detected — silently ignore.
      return;
    }

    const email = this.emailInput ? this.emailInput.value.trim() : '';

    if (!email) {
      this.showMessage('error', this.msgEmailRequired);
      if (this.emailInput) this.emailInput.focus();
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showMessage('error', this.msgEmailInvalid);
      if (this.emailInput) this.emailInput.focus();
      return;
    }

    let phone = this.phoneInput ? this.phoneInput.value.trim() : '';
    const phoneCountry = this.phoneCountrySelect
      ? (this.phoneCountrySelect.value || '').trim()
      : '';
    if (phone && phoneCountry) phone = `${phoneCountry} ${phone}`;

    const acceptsMarketing = !!(this.marketingInput && this.marketingInput.checked);

    const payload = {
      email,
      phone: phone || null,
      // Send the key the backend reads (`accepts_marketing`) AND the legacy
      // key (`marketing_opt_in`) so neither side silently drops the value
      // during/after a deploy.
      accepts_marketing: acceptsMarketing,
      marketing_opt_in: acceptsMarketing,
      product_sku: this.skuInput ? this.skuInput.value : null,
      country: this.countryInput ? this.countryInput.value : null,
      shop_domain: this.shopDomain || null,
      company: honeypot ? honeypot.value : ''
    };

    this.setLoading(true);
    this.clearMessage();

    fetch(this.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(async (response) => {
        let data = null;
        try {
          data = await response.json();
        } catch (e) {
          data = null;
        }
        this.setLoading(false);

        if (response.ok && data && data.ok) {
          this.fireAnalytics(payload);
          this.showSuccess(!!phone);
          return;
        }
        const msg = (data && data.error) || this.msgErrorGeneric;
        console.error('Back-in-stock submit failed', { status: response.status, data });
        this.showMessage('error', msg);
      })
      .catch((err) => {
        console.error('Back-in-stock network error', err);
        this.setLoading(false);
        this.showMessage('error', this.msgErrorNetwork);
      });
  }

  fireAnalytics(payload) {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'back_in_stock_subscribe', {
        product_sku: payload.product_sku,
        product_name: this.productTitle || undefined,
        country: payload.country || undefined
      });
    }
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Subscribe', {
        content_name: this.productTitle || undefined,
        value: 0,
        currency: this.currencyCode || undefined
      });
    }
  }

  setLoading(isLoading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = isLoading;
    this.submitBtn.textContent = isLoading ? this.loadingText : this.submitText;
  }

  clearMessage() {
    if (!this.messageEl) return;
    this.messageEl.hidden = true;
    this.messageEl.textContent = '';
    this.messageEl.classList.remove(
      'bis-form__message--success',
      'bis-form__message--error'
    );
  }

  showMessage(type, text) {
    if (!this.messageEl) return;
    this.messageEl.textContent = text;
    this.messageEl.hidden = false;
    this.messageEl.classList.remove(
      'bis-form__message--success',
      'bis-form__message--error'
    );
    this.messageEl.classList.add(
      type === 'success' ? 'bis-form__message--success' : 'bis-form__message--error'
    );
  }

  showSuccess(hasPhone) {
    if (this.form) this.form.reset();
    this.clearMessage();

    if (this.successTextEl) {
      this.successTextEl.textContent = hasPhone
        ? "We'll email and text you the moment this is back in stock."
        : "We'll email you the moment this is back in stock.";
    }
    if (this.panel) this.panel.hidden = true;
    if (this.successEl) this.successEl.hidden = false;

    // Auto-dismiss the surrounding modal after a beat so the user lands
    // back on the product page. Falls back gracefully if there's no
    // modal-dialog ancestor (e.g. the form is rendered inline somewhere).
    setTimeout(() => {
      const modal = this.closest('modal-dialog');
      if (modal && typeof modal.hide === 'function') modal.hide();
    }, 3000);
  }
}

if (!customElements.get('bis-form')) {
  customElements.define('bis-form', BisForm);
}
